export const idle = Symbol('idle');
